import api from './api';
import { UserSettings, ApiResponse } from '../types';

export const settingsService = {
  // User Settings
  async getUserSettings() {
    return api.get<ApiResponse<UserSettings>>('/user/settings');
  },

  async updateUserSettings(settings: Partial<UserSettings>) {
    return api.put<ApiResponse<UserSettings>>('/user/settings', settings);
  },

  // Broker Credentials
  async getBrokerCredentials() {
    return api.get<ApiResponse<any>>('/user/broker-credentials');
  },

  async updateBrokerCredentials(credentials: any) {
    return api.put<ApiResponse<any>>('/user/broker-credentials', credentials);
  },

  async testTelegram() {
    return api.post<ApiResponse<any>>('/user/settings/test-telegram');
  }
};
